import React from 'react';
interface ISkillButtons {
  label: string;
  id: string;
  onClick?: () => void;
  isActive?: boolean;
}
export const TechnicalSkillButton = (props: ISkillButtons) => {
  const { label, id, onClick, isActive } = props;
  return (
    <button
        key={id}
        onClick={onClick}
        className={`px-3 py-1 text-xs font-medium rounded-lg transition-colors ${
          isActive
            ? 'bg-emerald-600 text-white'
            : 'bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 hover:from-emerald-100 hover:to-emerald-200'
        }`}
    >
      { label }
    </button>
  );
};
export const BehavioralSkillButton = (props: ISkillButtons) => {
  const { label, id, onClick, isActive } = props;
  return (
    <button
        key={id}
        onClick={onClick}
        className={`px-3 py-1 text-xs font-medium rounded-lg transition-colors ${
          isActive
            ? 'bg-blue-600 text-white'
            : 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 hover:from-blue-100 hover:to-blue-200'
        }`}
    >
      { label }
    </button>
  );
};
